import 'slick-carousel/slick/slick'

export default class LogosSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-logos-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: false,

                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            });
        }

    }

};

new LogosSlider();